export const sanitiseSummaryAsText = (summary: string) => {
  return (summary || '')
    .replace(/<p>/g, '')
    .replace(/```/g, '')
    .replace(/<\/p>/g, '\n')
    .replace(/<strong style="color: rgb\(0, 208, 145\);">/g, '| ')
    .replace(/<\/strong>/g, '')
    .replace(/<strong>/g, '')
    .replace(/<strong style="color: #00d091;">/g, '| ')
    .replace(/<strong style='color: #00d091;'>/g, '| ')
    .replace(/<strong style="color: #000;">/g, '')
    .replace(/<strong style='color: #000;'>/g, '')
    .replace(/<br>/g, '\n')
    .replace(/\n\n+/g, '\n\n') // Remove leading whitespace before '|' character
    .replace(/^\|+/gm, '')
    .trim();
};

export const sanitiseSummaryAsHtml = (
  summary: string,
  { prefix }: { prefix?: string } = {}
) => {
  return [prefix, summary]
    .filter(Boolean)
    .join('<br /><br />')
    .replace(/\n/g, '<br>')
    .trim();
};
